import instance from "./axios";

export default instance;